module.exports = __webpack_public_path__ + "static/abonnement-2-75394c062ea01afa509ae58fc79f8488.svg";